import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { layerStyles } from "@/gis/layer/styles";
import {GeoJSON} from "ol/format";

const geojsonObject = require("@/gis/geojson/BL_202110_simp_1000m_a_3857.json");

export default class BundeslaenderLayer extends VectorLayer<any> {
  constructor() {

    const source = new VectorSource({
      features: new GeoJSON().readFeatures(geojsonObject),
    });

    const style = layerStyles["bundeslaender"];

    super({
      // background: 'white',
      source,
      style
    });
  }

}

